document.addEventListener('DOMContentLoaded', function() {

    var slider = document.querySelector('.customer-reviews-slider');
    var flickity = new Flickity(slider, {
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        on: {
            ready: function() {
                slider.classList.add('is-ready');
                window.addEventListener('resize', function () {
                    flickity.resize();
                });
            },
            scroll: function(progress) {
                var flkty = this,
                    progressBarMeter = document.querySelector('.customer-reviews-slider__progress-bar-meter');
                if (flkty.slides.length > 1) {
                    progress = Math.max(0, Math.min( 1, progress));
                    // dynamic width of the meter in %
                    var meterWidthPerc = 100 / (flkty.slides.length);
                    // available space
                    var availablePerc = 100 - meterWidthPerc;
                    // set meter position
                    progressBarMeter.style.width = meterWidthPerc + '%';
                    progressBarMeter.style.left = (meterWidthPerc * flkty.selectedIndex) + '%';
                }
                else {
                    // hide progress
                    document.querySelector('.customer-reviews-slider__progress-bar').style.visibility = 'hidden';
                }
            }

        }
    });

});